import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
// import 'element-ui/lib/theme-chalk/index.css'
import './theme/index.css'
import store from './store'
import i18n from './lang'
import axios from 'axios'
import VueAnalytics from 'vue-analytics'
// import 'normalize.css/normalize.css'

Vue.use(VueAnalytics, {
  id: 'UA-204311291-1',
  router,
  autoTracking: {
    // pageviewOnLoad: false
    pageviewTemplate (route) {
      return {
        page: route.path,
        title: 'MVPSTORE',
        location: window.location.href
      }
    }
  },
  commands: {
    trackName (name = 'unknown') {
      this.$ga.event('download', name)
    }
  }
})

axios.interceptors.request.use(config => {
  // 增加时间戳
  config.params = {
    _t: Date.parse(new Date()) / 1000,
    ...config.params
  }

  return config
}, error => {
  // 发送请求错误操作
  return Promise.reject(error)
})

axios.defaults.baseURL = process.env.VUE_APP_AXIOS
// eslint-disable-next-line no-unused-expressions
axios.defaults.headers
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
